module.exports = __webpack_public_path__ + "files/d7df10b5292a556362f454d53514414c.png";